export default "__VITE_PUBLIC_ASSET__4f548c86__"